import React from 'react';
import { Link } from 'react-router-dom';
import { BarChart3Icon, BoxIcon, LayoutDashboardIcon, LogOutIcon, PercentIcon, SettingsIcon, ShoppingBagIcon, TagIcon, UsersIcon, XIcon } from 'lucide-react';
import { Logo } from '../Logo';
export type AdminSection = 'dashboard' | 'productos' | 'stock' | 'pedidos' | 'clientes' | 'categorias' | 'descuentos' | 'configuracion';
export const ADMIN_NAV: {
  id: AdminSection;
  label: string;
  icon: React.ComponentType<{
    className?: string;
  }>;
  badge?: number;
}[] = [{
  id: 'dashboard',
  label: 'Dashboard',
  icon: LayoutDashboardIcon
}, {
  id: 'productos',
  label: 'Productos',
  icon: BoxIcon
}, {
  id: 'stock',
  label: 'Stock',
  icon: BarChart3Icon,
  badge: 3
}, {
  id: 'pedidos',
  label: 'Pedidos',
  icon: ShoppingBagIcon,
  badge: 2
}, {
  id: 'clientes',
  label: 'Clientes',
  icon: UsersIcon
}, {
  id: 'categorias',
  label: 'Categorías',
  icon: TagIcon
}, {
  id: 'descuentos',
  label: 'Descuentos',
  icon: PercentIcon
}, {
  id: 'configuracion',
  label: 'Configuración',
  icon: SettingsIcon
}];
interface AdminSidebarProps {
  active: AdminSection;
  onSelect: (section: AdminSection) => void;
  open: boolean;
  onClose: () => void;
}
export function AdminSidebar({
  active,
  onSelect,
  open,
  onClose
}: AdminSidebarProps) {
  const content = <div className="flex h-full flex-col bg-ink-800" data-id="element-134" data-mp="2d3eztmmsvbdh">
      <div className="flex h-16 items-center justify-between border-b border-white/10 px-6 lg:h-20" data-id="element-135" data-mp="39se6wybne743">
        <Logo to="/admin" size="sm" data-id="element-136" data-mp="34t9yi9wjsdet" />
        <button type="button" onClick={onClose} aria-label="Cerrar menú" className="p-1.5 text-white/50 hover:text-white lg:hidden" data-id="element-137" data-mp="34ucnude827sm">
          <XIcon className="h-5 w-5" data-id="element-138" data-mp="2vteldzjfm8c5" />
        </button>
      </div>

      <nav aria-label="Navegación del panel" className="flex-1 overflow-y-auto p-4" data-id="element-139" data-mp="1pcjcb1pdn2c1">
        <ul className="space-y-1" data-id="element-140" data-mp="1pagcjpyf9uu4">
          {ADMIN_NAV.map(({
          id,
          label,
          icon: Icon,
          badge
        }) => {
          const isActive = active === id;
          return <li key={id} data-id="element-141" data-mp="1lvwxvi8u94oe">
                <button type="button" onClick={() => {
              onSelect(id);
              onClose();
            }} aria-current={isActive ? 'page' : undefined} className={`flex w-full items-center gap-3 px-3 py-2.5 text-sm transition-colors ${isActive ? 'bg-pink-500/12 text-white' : 'text-white/50 hover:bg-white/5 hover:text-white'}`} data-id="element-142" data-mp="1lsitk4gm6leb">
                  <span className={`h-5 w-[2px] shrink-0 ${isActive ? 'bg-pink-500' : 'bg-transparent'}`} data-id="element-143" data-mp="t6g8ktgim3we" />
                  <Icon className={`h-[18px] w-[18px] shrink-0 ${isActive ? 'text-pink-500' : ''}`} data-id="element-144" data-mp="k5i4yc9znyec" />
                  <span className="flex-1 text-left" data-id="element-145" data-mp="5ijeokmvba17">{label}</span>
                  {badge && <span className="flex h-5 min-w-5 items-center justify-center rounded-full bg-pink-500 px-1.5 text-[10px] font-bold text-white" data-id="element-146" data-mp="jg82vr8ovr4">
                      {badge}
                    </span>}
                </button>
              </li>;
        })}
        </ul>
      </nav>

      <div className="border-t border-white/10 p-4" data-id="element-147" data-mp="oh5hc3y19978">
        <div className="flex items-center gap-3" data-id="element-148" data-mp="ofkm0c3w9m8b">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-pink-500 font-display text-base text-white" data-id="element-149" data-mp="jiu6bpw04snf">
            AZ
          </span>
          <div className="min-w-0 flex-1" data-id="element-150" data-mp="y91encsaovae">
            <p className="truncate text-sm font-semibold text-white" data-id="element-151" data-mp="t96oxck9abqx">
              Ana Zapata
            </p>
            <p className="truncate text-xs text-white/40" data-id="element-152" data-mp="178oi044l4b63">Administradora</p>
          </div>
          <Link to="/" aria-label="Cerrar sesión" className="p-2 text-white/40 transition-colors hover:text-pink-500" data-id="element-153" data-mp="129v2651ts82r">
            <LogOutIcon className="h-4 w-4" data-id="element-154" data-mp="31nvbm7zjgxez" />
          </Link>
        </div>
      </div>
    </div>;
  return <>
      <aside className="hidden w-64 shrink-0 border-r border-white/10 lg:fixed lg:inset-y-0 lg:left-0 lg:block" data-id="element-155" data-mp="36eli5ojpb6b9">
        {content}
      </aside>
      {open && <div className="fixed inset-0 z-50 lg:hidden" data-id="element-156" data-mp="3ai9sgezpwg07">
          <div className="absolute inset-0 bg-black/70" onClick={onClose} data-id="element-157" data-mp="2drhh1unqbc4r" />
          <div className="absolute inset-y-0 left-0 w-72 border-r border-white/10" data-id="element-158" data-mp="2iohejh6ij6k9">
            {content}
          </div>
        </div>}
    </>;
}